import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { UserStateService } from './user-state.service';
import { LocationHelperService } from 'src/app/shared/services/location-helper.service';

@Injectable({
  providedIn: 'root'
})
export class SsoService {

  constructor(
    private locationHelperService: LocationHelperService,
    private userStateService: UserStateService) { }

  ssoRedirect(username: string, companyId?: string, replacePath?: string, replaceSearchParameters?: URLSearchParams) {
    this.userStateService._persistState(false, replacePath, replaceSearchParameters);

    this.locationHelperService.setHref(environment.SSO_LOGIN_URL +
      '?id=' + encodeURIComponent(username) +
      '&cid=' + (companyId ? encodeURIComponent(companyId) : '') +
      '&url=' + window.location.origin);
  }
}
